/* eslint-disable max-len */
import { DriveStep } from "driver.js";
import { OrderProperty } from "types/order";
import { NewOrderPartyType } from "v2-types/order";
import { AssociationType, ModalState } from "../types";

export const convertToBytes = (size: number) => {
  if (size !== null) {
    if (size < 1024) {
      return `${size} bytes`;
    }
    if (size < 1024 * 1024) {
      return `${(size / 1024).toFixed(2)} KB`;
    }
    if (size < 1024 * 1024 * 1024) {
      return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    }
    if (size < 1024 * 1024 * 1024 * 1024) {
      return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
    }
    return `${(size / (1024 * 1024 * 1024 * 1024)).toFixed(2)} TB`;
  }
  return '';
};

export const unixTimestampToDate = (unixTimestamp: string) => {
  const date = new Date(parseInt(unixTimestamp, 10));
  if (!Number.isNaN(date.getTime())) {
    return date.toLocaleString([], {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  return '';
};

export function convertUnixTimestamp(timestamp: string) {
  const dateInt = parseInt(timestamp, 10);
  if (Number.isNaN(dateInt)) return "";

  const date = new Date(dateInt);

  const month = date.toLocaleString('en-US', { month: 'long' }).toLowerCase();
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${month} ${day}, ${year} ${hours}:${minutes}`;
}

export const mapEstatesToAssociations = (estates: OrderProperty[]): AssociationType[] => {
  return estates.map(estate => ({
    _id: estate._id,
    name: estate.address.address,
  }));
};

export const mapPartiesToAssociations = (parties: NewOrderPartyType[]): AssociationType[] => {
  return parties.map(party => ({
    _id: party._id,
    name: party.name,
    kinds: party.kinds,
  }));
};

export const orderAssociationsAlphabetically = (association: AssociationType[]) => {
  return association.sort((associationA, associationB) => {
    return associationA.name.localeCompare(associationB.name);
  });
};

export const getDeleteConfirmationMessage = (modalState: ModalState): string => {
  if (modalState.type === "deleteDocumentConfirmation") {
    return `Are you sure you want to delete the "${modalState.document?.description}" document?`;
  }

  if (modalState.type === "deleteFileConfirmation") {
    return `Are you sure you want to delete the "${modalState.file.filename}" file?`;
  }

  return "";
};

export const getToogleConfirmationMessage = (modalState: ModalState): string => {
  if (modalState.type === "toggleDocumentLock") {
    return `${modalState.documentTitle} document will be ${modalState.lock ? "locked" : "unlocked"}.\n 
    ${modalState.lock ? "This file won't be regenerated automatically when information changes." : "This file will be regenerated automatically when information changes."}\n
    Are you sure you want to ${modalState.lock ? "lock" : "unlock"} the document?`;
  }

  return "";
};

export const documentStepts: DriveStep[] = [
  {
    element: '#documents-view',
    popover: {
      title: 'Welcome to Documents',
      description: 'Manage all your important files in one place.',
      align: "start",
      side: "top"
    },
  },
  {
    element: '#add-document',
    popover: {
      title: 'Add New Document',
      description: `Here you can create multiples kind of documents.
          <br/><br/><strong>Signature Documents</strong>
          <br/>Documents requiring party signatures
          <br/><br/><strong>Template</strong> - Start with a pre-designed document template. Templates are reusable document formats with predefined layouts, fields, and styling. Perfect for contracts, invoices, agreements, or any document you create frequently.
           <br/><br/><strong>Upload</strong> - Have an existing document? Upload files directly from your device. Support for various formats including PDFs, Word documents, images, and more. 
           <br/><br/><strong>PDF/ZIP Bundle</strong> - Need to group multiple documents together? Create document bundles by:

PDF Bundle: Combine multiple files into a single PDF document. Ideal for creating comprehensive packages like closing documents or complete file sets.
ZIP Bundle: Compress multiple documents into a ZIP archive. Perfect for organizing related files while maintaining their original formats and reducing storage space.
          `,
    }
  },
  {
    element: '#search-documents-query',
    popover: {
      title: 'Search Documents',
      description: 'Quickly find any document by name, party or property!'
    }
  },
  {
    element: '#kind-tabs',
    popover: {
      title: "Document Kinds Tabs",
      description: `Navigate between different document kinds.<br/>
            <br/><strong>Auto Documents</strong>
          <br/>System- generated documents created automatically from templates
          <br/><br/><strong>Accounting Documents</strong>
          <br/>Financial and accounting-related documents

          `
    }
  },
  {
    element: "#documents-container-list",
    popover: {
      title: "Document List",
      description: "The displayed documents change according to the selected document tab."
    }
  }
];